import React, { useEffect, useState } from 'react';
import {
  TextField,
  Container,
  Grid,
  FormControl,
  Button,
  Snackbar,
} from '@mui/material';
import CustomForm from '../components/CustomForm';
import FormPopover from '../components/FormPopover';
import { useDispatch, useSelector } from 'react-redux';
import {
  getId,
  getText,
  updateTitle,
  updateText,
  putText,
} from '../features/editor/editorSlice';
import utils from '../utils/dataUtils';

import { diff } from '../utils/textUtils';
import { validateText } from '../features/text/textSlice';

// import { w3cwebsocket } from 'websocket';
// const socket = new w3cwebsocket('ws://127.0.0.1:8080');

let HOST = window.location.origin.replace(/^http/, 'ws');
const socket = new WebSocket(HOST);

export default function Editor() {
  const dispatch = useDispatch();
  const { connected, connectedAccount } = useSelector((store) => store.user);
  const { id, title, text } = useSelector((store) => store.editor);
  const [openPopup, setOpenPopup] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [socketOpen, setSocketOpen] = useState(false);
  const editable = true;

  useEffect(() => {
    if (!id) {
      dispatch(getId());
    } else {
      dispatch(getText({ textId: id }));
    }
  }, [id, dispatch]);

  useEffect(() => {
    setSocketOpen(socket.readyState === socket.OPEN);
  }, [socket.readyState]);

  const handleTitleChange = (event) =>
    dispatch(updateTitle({ title: event.target.value }));
  const handleChange = (event) => {
    const patch = diff(text, event.target.value);
    utils.postPatch(socket, id, patch);

    dispatch(updateText({ text: event.target.value }));
    dispatch(putText({ account: connectedAccount }));
  };

  const handleKeyDown = (event) => {
    const { selectionStart, selectionEnd } = event.target;
    utils.postKey({
      socket,
      id,
      keyCode: event.keyCode,
      selectionStart,
      selectionEnd,
    });
  };

  const handlePaste = (event) => {
    utils.postAction({
      socket,
      id,
      act: 'P',
      text: event.clipboardData.getData('Text'),
    });
  };

  const handleCopy = (event) => {
    utils.postAction({
      socket,
      id,
      act: 'C',
      text: event.clipboardData.getData('Text'),
    });
  };

  const handleCut = (event) => {
    utils.postAction({
      socket,
      id,
      act: 'X',
      text: event.clipboardData.getData('Text'),
    });
  };

  const handleCloseSnack = () => setShowSnackBar(false);

  return (
    <Container maxWidth='xl'>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <FormControl fullWidth sx={{ m: 1 }}>
            <TextField
              color='grey'
              id='title'
              label='Title'
              value={title}
              onChange={handleTitleChange}
              variant='standard'
              disabled={!connected || !editable || !socketOpen}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <FormControl fullWidth sx={{ m: 1 }}>
            <TextField
              color='grey'
              id='text'
              multiline
              minRows={30}
              maxRows={30}
              value={text}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              onPaste={handlePaste}
              onCopy={handleCopy}
              onCut={handleCut}
              disabled={!connected || !editable || !socketOpen}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <FormControl fullWidth sx={{ m: 1 }}>
            <Button
              onClick={() => {
                dispatch(putText({ account: connectedAccount, force: true }));
                setOpenPopup(true);
              }}
              disabled={
                !connected ||
                !editable ||
                text.length === 0 ||
                title.length === 0
              }
              color='primary'
              variant='contained'
            >
              mint
            </Button>
            <Button
              onClick={() => {
                dispatch(validateText({ id }));
              }}
              color='secondary'
              variant='outlined'
              style={{ marginTop: '0.5rem' }}
            >
              validate
            </Button>
            <Button
              onClick={() => {
                dispatch(getId());
              }}
              color='error'
              variant='outlined'
              style={{ marginTop: '0.5rem' }}
            >
              reset
            </Button>
          </FormControl>
        </Grid>
      </Grid>
      <FormPopover
        title='Preview'
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <CustomForm
          setOpenPopup={setOpenPopup}
          setSnackBarMessage={setSnackBarMessage}
          setShowSnackBar={setShowSnackBar}
          textId={id}
          title={title}
          text={text}
        />
      </FormPopover>
      <Snackbar
        open={showSnackBar}
        autoHideDuration={5000}
        onClose={handleCloseSnack}
        message={snackBarMessage}
      />
    </Container>
  );
}
